// import React, { Component } from "react";
// import { Link } from "react-router-dom";
// import {
//   FaBatteryFull,
//   FaShieldAlt,
//   FaChargingStation,
//   FaLeaf,
//   FaWifi,
//   FaFan,
//   FaTools,
//   FaPlug,
// } from "react-icons/fa";
// import parse from "html-react-parser";

// class CategoryInverters extends Component {
//   render() {
//     let publicUrl = process.env.PUBLIC_URL + "/";
//     let imagealt = "image";

//     return (
//       <div className="ltn__category-area ltn__product-gutter section-bg-1--- pt-115 pb-70">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="section-title-area ltn__section-title-2--- text-center">
//                 <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">
//                   Smart, Safe, Powerful Performance
//                 </h6>
//                 <h1 className="section-title">Key Features</h1>
//               </div>
//             </div>
//           </div>
//           <div className="row ltn__category-slider-active--- slick-arrow-1 justify-content-center go-top">
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link
//                 // to="/shop"
//                 >
//                   <span className="category-icon">
//                     {/* <i className="flaticon-car" /> */}
//                     <FaChargingStation color="#0D5540" size={30} />
//                   </span>
//                   <span className="category-number">01</span>
//                   <span className="category-title">Long Cycle Life</span>
//                   <span className="category-brief">
//                     Enjoy long-lasting power with a our ATOM Power battery
//                     designed for an extended cycle life
//                   </span>
//                   <span className="category-btn d-none">
//                     {/* <i className="flaticon-right-arrow" /> */}
//                     <FaChargingStation color="#0D5540" size={40} />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link
//                 // to="/shop"
//                 >
//                   <span className="category-icon">
//                     <i className="flaticon-swimming" />
//                   </span>
//                   <span className="category-number">02</span>
//                   <span className="category-title">Advanced BMS</span>
//                   <span className="category-brief">
//                     {/* We are dedicated to sustainability with eco-friendly
//                     batteries that lower your carbon footprint. */}
//                     An Advanced BMS keeps your battery running safely and
//                     efficiently, maximizing its lifespan and performance.
//                   </span>
//                   <span className="category-btn d-none">
//                     <i className="flaticon-right-arrow" />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link
//                 // to="/shop"
//                 >
//                   <span className="category-icon">
//                     <i className="flaticon-secure-shield" />
//                   </span>
//                   <span className="category-number">03</span>
//                   <span className="category-title">
//                     Fast Charging/  Discharging
//                   </span>
//                   <span className="category-brief">
//                     ATOM Power delivers fast charging and discharging for energy
//                     when you need it.
//                   </span>
//                   <span className="category-btn d-none">
//                     <i className="flaticon-right-arrow" />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link
//                 // to="/shop"
//                 >
//                   <span className="category-icon">
//                     <i className="flaticon-stethoscope" />
//                   </span>
//                   <span className="category-number">04</span>
//                   <span className="category-title">
//                     Environmentally Friendly
//                   </span>
//                   <span className="category-brief">
//                     ATOM Power offers eco-friendly batteries that reduce your
//                     carbon footprint.
//                   </span>
//                   <span className="category-btn d-none">
//                     <i className="flaticon-right-arrow" />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link
//                 // to="/shop"
//                 >
//                   <span className="category-icon">
//                     <i className="flaticon-book" />
//                   </span>
//                   <span className="category-number">05</span>
//                   <span className="category-title">Remote Monitoring</span>
//                   <span className="category-brief">
//                     ATOM Power allows remote monitoring for full control and
//                     insights.
//                   </span>
//                   <span className="category-btn d-none">
//                     <i className="flaticon-right-arrow" />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link
//                 // to="/shop"
//                 >
//                   <span className="category-icon">
//                     <i className="flaticon-bed-1" />
//                   </span>
//                   <span className="category-number">06</span>
//                   <span className="category-title">Quiet Operation</span>
//                   <span className="category-brief">
//                     ATOM Power ensures quiet operation, providing seamless
//                     energy without the noise.
//                   </span>
//                   <span className="category-btn d-none">
//                     <i className="flaticon-right-arrow" />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link
//                 // to="/shop"
//                 >
//                   <span className="category-icon">
//                     <i className="flaticon-home-2" />
//                   </span>
//                   <span className="category-number">07</span>
//                   <span className="category-title">WiFi Enabled</span>
//                   <span className="category-brief">
//                     ATOM Power’s WiFi-enabled batteries offer easy connectivity
//                     and remote control for convenience
//                   </span>
//                   <span className="category-btn d-none">
//                     <i className="flaticon-right-arrow" />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link to="/shop">
//                   <span className="category-icon">
//                     <i className="flaticon-slider" />
//                   </span>
//                   <span className="category-number">08</span>
//                   <span className="category-title">
//                     Compatible With Inverters
//                   </span>
//                   <span className="category-brief">
//                     Works with solar inverters, making it easy to integrate into
//                     existing solar setups.
//                   </span>
//                   <span className="category-btn d-none">
//                     <i className="flaticon-right-arrow" />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default CategoryInverters;

// import React, { Component } from "react";
// import { Link } from "react-router-dom";
// import {
//   FaBatteryFull,
//   FaShieldAlt,
//   FaChargingStation,
//   FaLeaf,
//   FaWifi,
//   FaFan,
//   FaTools,
//   FaPlug,
//   FaCogs,
//   FaHandsHelping,
//   FaLightbulb,
// } from "react-icons/fa";

// class CategoryInverters extends Component {
//   render() {
//     const featureData = [
//       {
//         id: 1,
//         title: "Efficiency",
//         description:
//           "Equipped with robust security features, this product meets multiple safety standards.",
//         icon: <FaCogs color="#0D5540" size={40} />,
//       },
//       {
//         id: 2,
//         title: "Safety",
//         description:
//           "Supports up to 200A charging current and seamless Li-ion battery BMS communication.",
//         icon: <FaShieldAlt color="#0D5540" size={40} />,
//       },
//       {
//         id: 3,
//         title: "All-in-One",
//         description:
//           "Features a modern industrial design, easy installation, and user-friendly operation.",
//         icon: <FaChargingStation color="#0D5540" size={40} />,
//       },
//       {
//         id: 4,
//         title: "Reliable",
//         description:
//           "Delivers high-quality pure sine wave AC power with IP65 protection.",
//         icon: <FaHandsHelping color="#0D5540" size={40} />,
//       },
//       {
//         id: 5,
//         title: "User-Friendly",
//         description:
//           "Exclusive Li-ion battery BMS dual activation and a cost-saving time-slot function for efficiency.",
//         icon: <FaFan color="#0D5540" size={40} />,
//       },
//       {
//         id: 6,
//         title: "Intelligent",
//         description:
//           "Features advanced MPPT with up to 99.9% efficiency and dual PV input current of up to 22A each.",
//         icon: <FaLightbulb color="#0D5540" size={40} />,
//       },
//     ];

//     return (
//       <div className="ltn__category-area ltn__product-gutter section-bg-1--- pt-115 pb-70">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="section-title-area ltn__section-title-2--- text-center">
//                 <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">
//                   Smart, Safe, Powerful Performance
//                 </h6>
//                 <h1 className="section-title">Key Features</h1>
//               </div>
//             </div>
//           </div>

//           <div className="row ltn__category-slider-active--- slick-arrow-1 justify-content-center go-top">
//             {featureData.map((feature) => (
//               <div
//                 key={feature.id}
//                 className="col-lg-3 col-md-4 col-sm-6 col-6"
//               >
//                 <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                   <Link
//                     to="#"
//                     onClick={(e) => e.preventDefault()}
//                     style={{
//                       pointerEvents: "none", // optional: disables hover click, fully non-interactive
//                       textDecoration: "none",
//                       color: "inherit",
//                       display: "block",
//                       cursor: "default", // optional: removes pointer cursor
//                     }}
//                   >
//                     <span className="category-icon">{feature.icon}</span>
//                     <span className="category-number">
//                       {feature.id.toString().padStart(2, "0")}
//                     </span>
//                     <span className="category-title">{feature.title}</span>
//                     <span className="category-brief">
//                       {feature.description}
//                     </span>
//                     <span className="category-btn d-none">{feature.icon}</span>
//                   </Link>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default CategoryInverters;

import React from "react";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";

const CategoryInverters = ({ features = [] }) => {
  return (
    <div className="ltn__category-area ltn__product-gutter section-bg-1--- pt-115 pb-70">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title-area ltn__section-title-2--- text-center">
              <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">
                Smart, Safe, Powerful Performance
              </h6>
              <h1 className="section-title">Key Features</h1>
            </div>
          </div>
        </div>

        <div className="row ltn__category-slider-active--- slick-arrow-1 justify-content-center go-top">
          {features.map((feature, index) => {
            const IconComponent = FaIcons[feature.iconName] || FaIcons.FaPlug;
            return (
              <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-6">
                <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
                  <Link
                    to="#"
                    onClick={(e) => e.preventDefault()}
                    style={{
                      pointerEvents: "none",
                      textDecoration: "none",
                      color: "inherit",
                      display: "block",
                      cursor: "default",
                    }}
                  >
                    <span className="category-icon">
                      <IconComponent color="#0D5540" size={40} />
                    </span>
                    <span className="category-number">
                      {(index + 1).toString().padStart(2, "0")}
                    </span>
                    <span className="category-title">{feature.title}</span>
                    <span className="category-brief">
                      {feature.description}
                    </span>
                    <span className="category-btn d-none">
                      <IconComponent color="#0D5540" size={40} />
                    </span>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CategoryInverters;
